import WorkflowModel from '@opsbase/lib-data-model/models/WorkflowModel';
import DataType from '@opsbase/lib-datatype/DataType/DataType';
import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useWorkflowCreate from '@opsbase/react-gql-hooks/workflow/useWorkflowCreate';
import useNewDataActionsContext from '@opsbase/web-ctrl-newdata/useNewDataActions';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import useNav from '@opsbase/web-nav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import Button from '@opsbase/web-ui/Button';
import React, { useCallback, useState } from 'react';
import WorkflowDialog from './WorkflowDialog';
export function WorkflowCreateDialog() {
    const { newWorkflow = {} } = useParams();
    const [workflow, setWorkflow] = useState(new WorkflowModel(newWorkflow));
    const { raise } = useNotificationActions();
    const { addItemsToType } = useNewDataActionsContext();
    const createWorkflow = useWorkflowCreate();
    const handleCreateWorkflow = useCallback(() => raise(createWorkflow({
        patch: { ...workflow, enabled: true },
    }).then(res => {
        addItemsToType(DataType.WORKFLOW, [res]);
    }), i18n.t('workflow-create-successful')), [raise, createWorkflow, workflow, addItemsToType]);
    const handleChangeTitle = useCallback(title => {
        setWorkflow(new WorkflowModel({
            ...workflow,
            title,
        }));
    }, [workflow]);
    const { goBack } = useNav();
    const handleClose = useCallback(() => {
        goBack();
    }, [goBack]);
    const self = useSelf();
    const editable = self.isPrimary || self.isSuperUser;
    return (React.createElement(Dialog, { size: DialogSize.XFULL_YFULL, padded: false, closable: false, title: workflow === null || workflow === void 0 ? void 0 : workflow.title, editableTitle: true, onChangeTitle: handleChangeTitle, scroll: true, buttonsLeft: React.createElement(Button, { onClick: handleClose, color: Palette.Grey, tabIndex: 1, label: i18n.t('cancel') }), buttonsRight: React.createElement(Button, { onClick: () => {
                handleCreateWorkflow().catch(doNothing);
                handleClose();
            }, tabIndex: 0, label: i18n.t('create') }) },
        React.createElement(WorkflowDialog, { workflow: workflow, onChange: setWorkflow, editable: editable })));
}
export default WorkflowCreateDialog;
